import { makeServicesTypesFromEnum } from '@/core/container/makeServicesTypes'

export enum TM_CODEMIRROR_EDITOR_SERVICES {
  TmCodemirrorEditorExtensionsSet,
  TmCodemirrorEditorExtensionsManager,
}

export type TmCodemirrorEditorServices = keyof typeof TM_CODEMIRROR_EDITOR_SERVICES

export const TM_CODEMIRROR_EDITOR_SERVICES_TYPES =
  makeServicesTypesFromEnum<TmCodemirrorEditorServices>(TM_CODEMIRROR_EDITOR_SERVICES)
